import { Typography } from "@mui/material";
import React from "react";

import Left from "assets/icons/chevron-left.svg";
import { primaryColor } from "theme";

const BottomActionButtons = ({
  handleBack,
  isDisabled,
  backButtonTitle,
  nextButtonTitle,
  handleSubmit
}) => {
  return (
    <div className="flex mt-6 justify-end gap-4">
      <div
        onClick={handleBack}
        className="flex items-center gap-2 cursor-pointer"
       >
        <img src={Left} alt="BackIcon" />
        <Typography sx={{ color: primaryColor, fontSize: ".875rem" }}>
          {backButtonTitle}
        </Typography>
      </div>
        <button
          disabled={isDisabled}
          onClick={handleSubmit}
          className="bg-[#3487F3] hover:bg-[#1f3765] text-white px-6 py-3 rounded-[8px] font-[500] text-[1rem] disabled:bg-[#9097A1] disabled:text-white"
        >
          {nextButtonTitle}
        </button>
    </div>
  );
};

export default BottomActionButtons;
